export const USER_ANALYSIS = 'userAnalysis';
export const GET_USERLIST = `${USER_ANALYSIS}/getUserListAction`;
export const GET_CYCLE = `${USER_ANALYSIS}/getCycleListAction`;
export const GET_USER_ANALYSIS = `${USER_ANALYSIS}/getUserAnalysisAction`;
export const GET_CURRENT_CYCLE_STATUS = `${USER_ANALYSIS}/getCurrentCycleStatusAction`;
export const GET_ASSESSOR_FEEDBACK = `${USER_ANALYSIS}/getAssessorFeedbackAction`;
export const GET_USER_PROFICIENCYLEVEL = `${USER_ANALYSIS}/getUserProficiencyLevelAction`;
export const GET_SCORE_DETAILS = `${USER_ANALYSIS}/getScoreDetailsAction`;
export const GET_CURRENT_RESPONSE_DATA = `${USER_ANALYSIS}/getCurrentResponseDataAction`;
export const SAVE_RESPONSE = `${USER_ANALYSIS}/saveResponseAction`;
export const DELETE_ATTACHMENT = `${USER_ANALYSIS}/deleteAttachmentAction`;
export const DOWNLOAD_ATTACHMENT = `${USER_ANALYSIS}/downloadAttachmentAction`;
export const RESET_ASSESSMENT = `${USER_ANALYSIS}/resetExamAction`;
export const GET_SELF_CYCLE = `${USER_ANALYSIS}/getSelfCycleListAction`;
export const TAKE_SELF_ASSESSMENT=`${USER_ANALYSIS}/getTakeSelfAssessmentAction`;
export const GET_EVAL_CYCLE= `${USER_ANALYSIS}/getEvaluationCycleListAction`;
export const GET_EVAL_SCORE_DETAILS = `${USER_ANALYSIS}/getEvaluateScoreDetailsAction`;